<!-- eslint-disable vue/no-mutating-props -->
<script setup lang="ts">
import type { SiteBlock } from '~/types/types'

defineProps<{ block: SiteBlock }>()

const COUNTS = [
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' }
] as const
</script>

<template>
  <!-- eslint-disable vue/no-mutating-props -->
  <UFormField label="Title">
    <UInput
      v-model="block.data.title"
      class="w-full"
    />
  </UFormField>
  <UFormField label="Source">
    <USelect
      v-model="block.data.source"
      :items="[
        { label: 'Latest', value: 'latest' },
        { label: 'Popular', value: 'popular' }
      ]"
      class="w-full"
    />
  </UFormField>
  <UFormField label="Posts shown">
    <SiteEditorOptionToggle
      :options="COUNTS"
      :model-value="block.data.count ?? 3"
      @update:model-value="block.data.count = Number($event)"
    />
  </UFormField>
</template>
